import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';

import containersPropTypes from '../../proptypes/containers';
import milestonesPropTypes from '../../proptypes/milestones';
import ContainerAccordion from './ContainerAccordion';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2, 0),
    },
    accordionTitle: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
    },
    titleScore: {
        minWidth: '300px',
        display: 'flex',
        justifyContent: 'flex-start',
        '&>*:nth-of-type(2)': {
            marginLeft: theme.spacing(2),
        },
    },
    accordionDetail: {
        flexDirection: 'column',
    },
}));

const ContainersAccordion = ({
    containers,
    containersReference,
    milestones,
    disabled,
}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            {containers &&
                containers.map((container) => {
                    const containerReference = containersReference?.find(
                        (containerReference) => containerReference.name === container.name
                    );
                    return (
                        <React.Fragment key={container.name}>
                            <ContainerAccordion
                                container={container}
                                containerReference={containerReference}
                                milestones={milestones}
                                disabled={disabled}
                            />
                        </React.Fragment>
                    );
                })}
        </div>
    );
};

ContainersAccordion.propTypes = {
    containers: containersPropTypes,
    containersReference: containersPropTypes,
    scenarioReferenceId: PropTypes.string,
    milestones: milestonesPropTypes,
    disabled: PropTypes.bool,
};
export default ContainersAccordion;
